var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBmiProgress = function SvgBmiProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 296 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bmi_progress_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 0a6 6 0 1 1 0 12H6.5a6 6 0 0 1 0-12h283Z",
    fill: "url(#bmi_progress_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    fill: "#E5E7EB"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5-32h1v220h-1V-32ZM42.375-32h1v220h-1V-32ZM77.25-32h1v220h-1V-32ZM112.125-32h1v220h-1V-32ZM147-32h1v220h-1V-32ZM181.875-32h1v220h-1V-32ZM216.75-32h1v220h-1V-32ZM251.625-32h1v220h-1V-32ZM286.5-32h1v220h-1V-32Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bmi_progress_svg__b",
    x1: 0.5,
    y1: 6,
    x2: 284.5,
    y2: 6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.016,
    stopColor: "#58CEC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197,
    stopColor: "#53C7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388,
    stopColor: "#44AB38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#B9C275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#F7E18A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#FD6A78"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bmi_progress_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 295,
    height: 12,
    rx: 6,
    fill: "#fff"
  })))));
};
export default SvgBmiProgress;